module.exports = __webpack_public_path__ + "static/img/GoDaddy3.6b84170.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faq/GoDaddy3.png
// module id = 1774
// module chunks = 5